const countFiles = (array, id, number = true) => {
  let filtered = array.filter((f) => f.adaptationId === id);
  
  if (number) return filtered.length;

  return filtered;
};

export default countFiles;
